<template>
  <div class="ticket-portal-listing">
    <loading-placeholder v-if="isLoading" :lines="10" />
    <template v-else>
      <ticket-portal-header
        :ticket-portal-name="data.ticketPortalName"
        :customer="data.customer"
        :logo-url="data.logoUrl"
        hide-home-on-mobile
      />
      <div class="title scripty">Your tickets</div>
      <div class="listing">
        <router-link 
          v-for="ticket in data.listConvos" 
          :key="ticket.id" 
          :to="RouteAssistant.getTicketPortalDetailRoute($route.params.accountId, $route.params.mailboxId, ticket.id)"
        >
          <div class="date">{{ ticket.lastUpdated }}</div>  
          <div class="subject"><span v-if="ticket.refNumber">#{{ticket.refNumber}}:&nbsp;</span>{{ ticket.subject }}</div>
          <status-chicklet v-if="ticket.status" :status="ticket.status" />
        </router-link> 
      </div>
      <ticket-portal-footer />
    </template>   
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */
import TicketPortalHeader from './components/ticket-portal-header.vue'
import TicketPortalFooter from './components/ticket-portal-footer.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import { ITicketPortalOutputListing } from '@/api/types/response.types'

/* API */
import TicketPortalAPI from '@/api/modules/ticket-portal.api'

export default defineComponent({
  name: 'TicketPortalListing',

  components: { TicketPortalHeader, TicketPortalFooter },

  data() {
    return {
      RouteAssistant,
      isLoading: true,
      data: {} as ITicketPortalOutputListing,
    }
  },

  head(): any {
    return {
      title: this.data.ticketPortalName,
    }
  },

  async created() {
    this.isLoading = true
    await this.getTickets()
    this.isLoading = false
  },

  methods: {
    async getTickets() {
      try {
        this.data = await TicketPortalAPI.get_Listing(
          this.$route.params.mailboxId,
        )
      } catch (error) {
        this.$error.emit(error)
      }
    },
  },
})
</script>

<style lang="scss">
.ticket-portal-listing {
  $side-margin-px: 20px;

  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--color-background-primary);
  padding-bottom: 100px;

  .loading-placeholder {
    margin-top: 20px;
    width: 90%;
  }

  .title {
    margin: 20px 0;
    font-size: 36px;
    color: var(--color-text-secondary);
  }

  .listing {
    width: 800px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    @include media-breakpoint-down(sm) {
      width: 100%;
    }

    > a {
      display: flex;
      align-items: center;
      background-color: var(--color-background-header);
      border: solid 1px $color--gray-30;
      border-radius: 8px;
      padding: 14px $side-margin-px;
      gap: 20px;

      @include media-breakpoint-up(md) {
        @include standard-box-shadow;
      }

      @include media-breakpoint-down(sm) {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        border-radius: 0px;
        border-left: none;
        border-right: none;
      }

      cursor: pointer;

      > .subject {
        @include lettering--p;

        > span {
          font-weight: $bold;
        }
      }

      > .date {
        @include lettering--p-sm;
        font-weight: $bold;
        white-space: nowrap;
        min-width: 130px;
        max-width: 130px;
      }

      &:hover {
        background-color: var(--color-background-blue);
        text-decoration: none;
      }

      .status-chicklet {
        margin-left: auto;
        max-width: 150px;
      }
    }
  }
}
</style>
